<template>
  <div class="ncdn-portal">
    <div class="background  pb-rem">
      <div class="nkn-container">
        <div class="flex">
          <div class="details-1">
            <h1 class="title">{{$t('nCDN.banner1.title')}}</h1>
            <p class="text">{{$t('nCDN.banner1.text')}}</p>
          </div>
          <div class="banner-1">
            <img v-lazy="'/static/img/ncdn/ncdn-banner-1.png'">
          </div>
        </div>
      </div>
    </div>
    <div class="background pt-rem pb-rem">
      <div class="nkn-container">
        <div class="flex">
          <div class="banner-1">
            <img v-if="$i18n.locale === 'zh'" v-lazy="'/static/img/ncdn/ncdn-banner-22.png'">
            <img v-else v-lazy="'/static/img/ncdn/ncdn-banner-2.png'">
          </div>
          <div class="details-1">
            <h1 class="title">{{$t('nCDN.banner2.title')}}</h1>
            <p class="text">{{$t('nCDN.banner2.text')}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="background pt-rem pb-rem">
      <div class="nkn-container">
        <div class="flex">
          <div class="details-1">
            <h1 class="title">{{$t('nCDN.banner3.title')}}</h1>
            <p class="text">{{$t('nCDN.banner3.text')}}</p>
          </div>
          <div class="banner-1">
            <img v-lazy="'/static/img/ncdn/ncdn-banner-3.png'">
          </div>
        </div>
      </div>
    </div>
    <div class="background pt-rem pb-rem">
      <div class="nkn-container">
        <div class="flex">
          <div class="banner-2">
            <div>
            <img v-lazy="'/static/img/ncdn/ncdn-banner-4.png'">
            </div>
            <div>
            <img v-lazy="'/static/img/ncdn/ncdn-banner-5.png'">
            </div>
            <div>
            <img v-lazy="'/static/img/ncdn/ncdn-banner-6.png'">
            </div>
          </div>
          <div class="details-1">
            <h1 class="title">{{$t('nCDN.banner4.title')}}</h1>
            <p class="text">{{$t('nCDN.banner4.text')}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="background pt-rem pb-rem">
      <div class="nkn-container">
        <div class="flex">
          <div class="details-1">
            <h1 class="title">{{$t('nCDN.banner5.title')}}</h1>
            <p class="text">{{$t('nCDN.banner5.text')}}</p>
          </div>
          <div class="banner-2">
            <div class="column icon-title-item">
              <img v-lazy="'/static/img/ncdn/ncdn-banner-7.png'" style="width:auto;height:6rem;">
              <span>{{$t('nCDN.banner5.icon1')}}</span>
            </div>
            <div class="column icon-title-item" style="margin-left: 1rem;">
              <img v-lazy="'/static/img/ncdn/ncdn-banner-8.png'" style="width:auto;height:4.5rem;margin-top:1rem;margin-bottom:10px;">
              <span>{{$t('nCDN.banner5.icon2')}}</span>
            </div>
            <div class="column icon-title-item">
              <img v-lazy="'/static/img/ncdn/ncdn-banner-9.png'" style="width:auto;height:6rem;">
              <span>{{$t('nCDN.banner5.icon3')}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="background pt-rem pb-rem">
      <div class="nkn-container">
        <div class="flex">
          <div class="banner-2">
            <div class="column icon-title-item">
              <font-awesome-icon :icon="['fas','space-shuttle']" rotation="270" size="5x" style="margin-top: 2rem; color:darkred;" />
              <span>{{$t('nCDN.banner6.icon1')}}</span>
            </div>
            <div class="column icon-title-item">
              <font-awesome-icon :icon="['fas', 'file']" size="5x" style="margin-top: 2rem; color:#1791f2;"  />
              <span>{{$t('nCDN.banner6.icon2')}}</span>
            </div>
            <div class="column icon-title-item">
              <font-awesome-icon :icon="['fas','cloud-download-alt']" size="5x" style="margin-top: 2rem; color:#3752C2;"  />
              <span>{{$t('nCDN.banner6.icon3')}}</span>
            </div>
          </div>
          <div class="details-1">
            <h1 class="title"><a class="link" href="https://ncdn.io" target="_blank">{{$t('nCDN.banner6.title')}}</a></h1>
            <p class="text">{{$t('nCDN.banner6.text')}}</p>
            <a class="link" href="https://ncdn.io" target="_blank">https://ncdn.io</a>
          </div>
        </div>
      </div>
    </div>
    <!--<div class="background pt-rem pb-rem">
      <div class="nkn-container">
        <div class="common-sub-title">Customer and Partners</div>
        <div class="flex mt-50">
          <div class="flex justify-around align-center" style="width:100%">
            <img class="aqi-logo" v-lazy="'/static/img/ncdn/iq-logo-201801.png'"/>
            <img class="mp-logo" v-lazy="'/static/img/ncdn/mp-logo.png'"/>
          </div>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    components: {},
    computed: {
      ...mapGetters({
        lang: 'getLang'
      })
    },
    metaInfo() {
      if (this.$i18n.locale === 'zh') {
        return {
          title: 'nCDN',
          // titleTemplate: '%s - by vue-meta',
          htmlAttrs: {
            lang: this.$i18n.locale
          },
          attribute: '',
          meta: [
            {name: 'keywords', content: 'NKN,nkn,P2P,Network,BlockChain'},
            {
              name: 'description',
              content: 'nCDN。'
            }
          ]
        }
      } else {
        return {
          title: 'nCDN',
          // titleTemplate: '%s - by vue-meta',
          htmlAttrs: {
            lang: this.$i18n.locale
          },
          meta: [
            {name: 'keywords', content: 'NKN,nkn,P2P,Network,BlockChain'},
            {
              name: 'description',
              content: 'nCDN.'
            }
          ]
        }
      }

    }
  }
</script>

<style lang="scss" scoped>
  .ncdn-portal {
    position: relative;
  }

  .nkn-container {
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }

  .details-1 {
    max-width: 450px;
    width:100%;
    flex-shrink: 0;
    align-self: center;

    .title {
      font-size: 1.2rem;
      color: #0096FF;
      font-weight: 500;
    }

    .subheader {
      font-size: 0.9rem;
      color: #0096FF;
      font-weight: 500;
    }

    .text {
      font-size: 0.75rem;
      color: #24397D;
      font-weight: 400;
      margin-bottom: 10px;
      line-height: 1rem;
      margin-top: .75rem;
    }
  }
  .details-2 {
    width: 50%;
    flex-shrink: 0;
    align-self: center;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
    .title {
      font-size: 1.2rem;
      color: #0096FF;
      font-weight: 500;
    }

    .subheader {
      font-size: 0.9rem;
      color: #0096FF;
      font-weight: 500;
    }

    .text {
      font-size: 0.75rem;
      color: #24397D;
      font-weight: 400;
      margin-bottom: 10px;
      line-height: 1rem;
      margin-top: .75rem;
    }
  }

  .banner-1 {
    flex-shrink: 1; max-width: 600px;
    img {
      width: 100%;
    }
  }
  .banner-2{
    display: flex; max-width: 600px;width:100%; align-items: center;justify-content: space-around;
    div{
      flex-shrink: 1;flex-grow: 0; margin-right: 10px;
      img{display: block;height: 100%;width:100%;

      }
    }
  }
  .icon-title-item{
    display: flex;flex-direction: column; height: 100%; justify-content: center; align-items: center;
    padding-bottom: 20px;
    span{margin-top: 20px;}
  }
  .aqi-logo{width: auto;height: 70px;}
  .mp-logo{width: auto;height: 40px; }
</style>



// WEBPACK FOOTER //
// src/views/NCdnPortal.vue